import React, {useContext} from 'react';
import {NavLink, Link} from 'react-router-dom';
import logo from 'image/logo/logo-header-main.png';
import ic_close from 'image/icon/ic_close_b.svg';
import ic_menu from 'image/icon/ic_menu_b.svg';

import firebase from 'library/firebase-config.js';
import 'firebase/auth';
import { authContext } from '../../shared/App';
const auth = firebase.auth();

const nav = [
	{
		name: 'home', 
		path: '/admin/home',
		lnb: null
	},{
		name: 'about us', 
		path: '/admin/about',
		lnb: null
	},{
		name: 'portfolio', 
		path: '/admin/portfolio',
		lnb: null
	},{
		name: 'recruit', 
		path: '/admin/recruit',
		lnb: null
	},{
		name: 'customer center', 
		path: '/admin/customer',
		lnb: null
	},
]

const HeaderAdmin = (props) => {

	const handleLogout = ()=> {
		auth.signOut();
	}

	const {redirectToLogin} = useContext(authContext);


  return (
    <header className="HeaderAdmin">
      <div className="con">
			<Link to ="/admin" className=" header-logo header-admin-logo">

				<img src={logo} alt="logo"/>
				<p>admin</p>

      </Link>


			<div className={`header-left wrap-gnb-pc nav-admin ${!redirectToLogin ? `show` : ``}`}>
				<ul className="header-gnb font-gnb">
					{nav.map((el, index) => {
						return 	<li key = {index}>
											<NavLink activeClassName="gnb-active" to ={el.path}>{el.name}</NavLink>
										</li>
					})}
				</ul>

				<div className={`btn-logout`} onClick={handleLogout}>
					<p>로그아웃</p>
				</div>

			</div>



			{!redirectToLogin 
			? <div className="wrap-gnb-mobile"  onClick = {props.menuClickHandler}>
					<img className="ic-menu"  src={props.isMenuClicked ? ic_close :  ic_menu} alt="menu"/>
				</div>
			: ""}
			


		</div>
    </header>
  );
}

export default HeaderAdmin;